import Azure from './Azure'

const AzureConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false
				},
				toolbar: {
					display: false
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	},
	auth: [],
	routes: [
		{
			path: '/azure',
			component: Azure
		}
	]
}

export default AzureConfig
